import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssVarsProvider, extendTheme } from '@mui/joy/styles';
import Home from './Home';

const theme = extendTheme({
  fontFamily: {
    body: "'Poppins', sans-serif",
    display: "'Poppins', sans-serif",
  },
});

function App() {
  return (
    <CssVarsProvider theme={theme}>
      <Router>
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </div>
      </Router>
    </CssVarsProvider>
  );
}

export default App;
